import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-feature-badge',
  template: `
    <span 
      *ngIf="plan"
      [ngClass]="badgeClass"
      class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full">
      {{ plan }}
      <mat-icon *ngIf="showIcon" class="ml-1" style="font-size: 14px; width: 14px; height: 14px;">
        {{ locked ? 'lock' : 'verified' }}
      </mat-icon>
    </span>
  `,
  styles: []
})
export class FeatureBadgeComponent {
  @Input() plan: 'BASIC' | 'PRO' | 'ENTERPRISE' | null = null;
  @Input() locked: boolean = true;
  @Input() showIcon: boolean = false;

  get badgeClass(): string {
    const baseClasses = 'inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full';
    
    switch(this.plan) {
      case 'BASIC':
        return this.locked 
          ? 'bg-blue-100 text-blue-800' 
          : 'bg-blue-500 text-white';
      case 'PRO':
        return this.locked 
          ? 'bg-purple-100 text-purple-800' 
          : 'bg-purple-500 text-white';
      case 'ENTERPRISE':
        return this.locked 
          ? 'bg-yellow-100 text-yellow-800' 
          : 'bg-yellow-500 text-white';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  }
}